/* STRAIGHT LEG — homepage «La torcia» (21 ott 2026): comparsa allo scorrere, parallasse, torcia sul quadro.
   Ogni sezione carica questo file: le funzioni partono una volta sola per elemento (data-slh-ok). */
(function () {
  if (window.__slHome) { window.__slHome.avvia(); return; }
  document.documentElement.classList.add('slh-js');
  const lento = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;

  // parallasse: spostamento = posizione nello schermo (-1..1) x margine dell'immagine, così non resta mai un bordo vuoto
  let pezzi = [];
  function parallasse() {
    if (lento) return;
    const h = innerHeight;
    pezzi.forEach(([im, k]) => {
      const b = im.parentElement.getBoundingClientRect();
      if (b.bottom < 0 || b.top > h) return;
      const q = Math.max(-1, Math.min(1, ((b.top + b.height / 2) - h / 2) / (h / 2 + b.height / 2)));
      im.style.transform = `translateY(${-q * b.height * k}px)`;
    });
  }
  let inCoda = false;
  addEventListener('scroll', () => { if (!inCoda) { inCoda = true; requestAnimationFrame(() => { inCoda = false; parallasse(); }); } }, { passive: true });

  function torcia(sez) {
    const q = sez.querySelector('[data-slh-quadro]'), did = sez.querySelector('[data-slh-did]'), sugg = sez.querySelector('[data-slh-sugg]');
    if (!q) return;
    let x = 14, y = 74, tx = 14, ty = 74, r = 0, tr = 0, acceso = false, intro = !lento, mano = false, t0 = 0, svelato = false;
    const R = () => q.clientWidth * 0.27;
    const svela = () => { if (!svelato) { svelato = true; did && did.classList.add('svelata'); } };
    const puntatore = matchMedia('(hover: hover)').matches;
    if (lento) { x = tx = 47; y = ty = 30; svela(); sugg && sugg.classList.add('on'); }
    function passo(t) {
      if (intro) { // la torcia entra dal basso (la carta del Joker) e sale fino al volto
        if (!t0) t0 = t;
        const k = Math.min(1, (t - t0) / 2600), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        tx = 14 + 33 * e; ty = 74 - 45 * e - Math.sin(k * Math.PI) * 8; tr = R() * Math.min(1, k * 2.2);
        if (k > .55) svela();
        if (k >= 1) { intro = false; sugg && sugg.classList.add('on'); }
      } else if (!mano && !acceso && !puntatore && !lento) { // telefono: la torcia gira da sola sul volto
        const s = t / 1000; tx = 47 + Math.sin(s * .7) * 17; ty = 34 + Math.sin(s * 1.1) * 15;
      }
      if (!intro) tr = acceso ? Math.hypot(q.clientWidth, q.clientHeight) * 1.4 : R();
      x += (tx - x) * .14; y += (ty - y) * .14; r += (tr - r) * (acceso ? .06 : .12);
      q.style.setProperty('--x', x + '%'); q.style.setProperty('--y', y + '%'); q.style.setProperty('--r', r + 'px');
      requestAnimationFrame(passo);
    }
    const punta = (cx, cy) => { const b = q.getBoundingClientRect(); tx = (cx - b.left) / b.width * 100; ty = (cy - b.top) / b.height * 100; };
    sez.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const s = sez.getBoundingClientRect();
      sez.style.setProperty('--wx', (e.clientX - s.left) + 'px'); sez.style.setProperty('--wy', (e.clientY - s.top) + 'px');
      if (intro) return; mano = true; punta(e.clientX, e.clientY); svela();
    });
    q.addEventListener('touchmove', (e) => { if (intro) return; mano = true; punta(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    q.addEventListener('click', () => { if (intro) return; acceso = !acceso; svela(); });
    const imgs = [...q.querySelectorAll('img')]; let pronte = 0;
    const via = () => { if (++pronte === imgs.length) requestAnimationFrame(passo); };
    if (!imgs.length) requestAnimationFrame(passo);
    imgs.forEach((im) => (im.complete ? via() : (im.addEventListener('load', via, { once: true }), im.addEventListener('error', via, { once: true }))));
  }

  // prima e dopo: quando il quadro entra nello schermo la linea scorre da sola (prima tutto antico, poi l'opera, poi a metà);
  // dopo si trascina col dito o col mouse, o con le frecce della tastiera
  function primaDopo(ba) {
    let p = 100, tp = 100, tiro = false, toccato = lento, t0 = 0, partito = false;
    if (lento) p = tp = 50;
    function passo(t) {
      if (!toccato) {
        if (!t0) t0 = t;
        const s = (t - t0) / 1000;
        tp = s < .6 ? 100 : s < 2.6 ? 100 - 92 * Math.sin(Math.min(1, (s - .6) / 2) * Math.PI / 2) : s < 4 ? 8 + 42 * ((s - 2.6) / 1.4) : 50 + Math.sin((s - 4) * 1.3) * 5;
      }
      p += (tp - p) * .12;
      ba.style.setProperty('--p', p + '%'); ba.setAttribute('aria-valuenow', Math.round(100 - p));
      requestAnimationFrame(passo);
    }
    const muovi = (cx) => { const b = ba.getBoundingClientRect(); tp = Math.max(0, Math.min(100, (cx - b.left) / b.width * 100)); toccato = true; };
    ba.addEventListener('pointerdown', (e) => { tiro = true; muovi(e.clientX); ba.setPointerCapture(e.pointerId); });
    ba.addEventListener('pointermove', (e) => { if (tiro || (e.pointerType === 'mouse' && t0)) muovi(e.clientX); });
    ba.addEventListener('pointerup', () => { tiro = false; });
    ba.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { toccato = true; tp = Math.max(0, tp - 5); }
      if (e.key === 'ArrowRight') { toccato = true; tp = Math.min(100, tp + 5); }
    });
    const parti = () => { if (!partito) { partito = true; requestAnimationFrame(passo); } };
    if ('IntersectionObserver' in window) {
      const o = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { o.disconnect(); parti(); } }, { threshold: .4 });
      o.observe(ba);
    } else parti();
  }

  function avvia() {
    document.querySelectorAll('[data-slh-ba]:not([data-slh-ok])').forEach((ba) => { ba.dataset.slhOk = 1; primaDopo(ba); });
    document.querySelectorAll('.slh .rv:not([data-slh-ok])').forEach((el) => { el.dataset.slhOk = 1; io ? io.observe(el) : el.classList.add('in'); });
    document.querySelectorAll('[data-slh-parallasse]:not([data-slh-ok])').forEach((im) => { im.dataset.slhOk = 1; pezzi.push([im, parseFloat(im.dataset.slhParallasse) || .07]); });
    document.querySelectorAll('[data-slh-torcia]:not([data-slh-ok])').forEach((s) => { s.dataset.slhOk = 1; torcia(s); });
    pezzi = pezzi.filter(([im]) => document.contains(im));
    parallasse();
  }
  window.__slHome = { avvia };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
  document.addEventListener('shopify:section:load', avvia);
})();
